export enum CadastroHistoricoTipo {
  CRIAR_CADASTRO = 'CRIAR_CADASTRO',
  ALTERAR_CADASTRO = 'ALTERAR_CADASTRO',
  ALTERAR_PROPRIETARIO = 'ALTERAR_PROPRIETARIO',
  ALTERAR_IMOVEL = 'ALTERAR_IMOVEL',
  CRIAR_DOCUMENTO = 'CRIAR_DOCUMENTO',
  ALTERAR_DOCUMENTO = 'ALTERAR_DOCUMENTO',
}
